import { v4 as uuidv4 } from 'uuid';
import { useFlags } from 'src/feature-flags/FlagsHook';
import type { CardProps } from 'src/notifications/cardTypes';
import NotificationCardShell from '../NotificationCardShell';
import NotificationDetailRow from '../NotificationDetailRow';
import NotificationLinkButton from '../NotificationLinkButton';
import { formatFileSize } from 'src/utils/fileSizeFormatting';

const alsoFound = (names: string[]) => {
  if (names.length === 0) return '';
  const listed = new Intl.ListFormat('en-GB', { type: 'conjunction' }).format(names);
  return ` It also has information about ${listed}, who ${names.length === 1 ? "isn't a client" : "aren't clients"} yet.`;
};

export default function DetectionCompleteCard({
  notification,
  payload,
  onClose,
}: CardProps<'UPLOAD_DETECTION_COMPLETE'>) {
  const { flagEnabledDataUploadFamilySuggestions } = useFlags();
  const failed = payload.status === 'FAILED';
  const peopleFound =
    flagEnabledDataUploadFamilySuggestions && !failed ? (payload.people_found ?? []) : [];

  return (
    <NotificationCardShell
      notification={notification}
      title={failed ? 'Upload could not be processed' : 'Upload processed'}
      body={
        failed
          ? 'We could not process your uploaded document.'
          : `Your uploaded document has finished processing.${alsoFound(peopleFound)}`
      }
      clientId={payload.client_id}
      details={
        <>
          {payload.file_name && <NotificationDetailRow label="File" value={payload.file_name} />}
          {payload.file_size != null && (
            <NotificationDetailRow label="Size" value={formatFileSize(payload.file_size)} />
          )}
        </>
      }
      actions={
        <>
          <NotificationLinkButton
            to={`/client/${payload.client_id}/document/add`}
            onClose={onClose}
          >
            View
          </NotificationLinkButton>
          {!failed && (
            <NotificationLinkButton
              primary
              to={`/client/${payload.client_id}/detected-entities?fileId=${payload.file_id}&fileName=${encodeURIComponent(payload.file_name ?? '')}&guid=${uuidv4()}`}
              onClose={onClose}
            >
              Process
            </NotificationLinkButton>
          )}
        </>
      }
    />
  );
}
